import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { refreshToken, logout } from "../../slices/userSlice";
import { toast } from "react-toastify";


export default function AuthExpirationWatcher() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const token = useSelector(
        (state) => state.user.token
    );


    useEffect(() => {

        if (!token) {
            return;
        }


        const tokenPayload = JSON.parse(
            atob(token.split(".")[1])
        );


        const expiration = tokenPayload.exp * 1000;

        const timeRemaining = expiration - Date.now();


        const timer = setTimeout(async () => {

            try {

                // Try getting a new access token
                await dispatch(refreshToken()).unwrap();


            } catch(error) {

                toast.error(
                    "Your session has expired. Please log in again."
                );


                dispatch(logout());


                navigate("/login", {
                    replace:true
                });

            }


        }, timeRemaining);



        return () => clearTimeout(timer);


    }, [token, dispatch, navigate]);


    return null;
}